//import React from 'react';
// FormElements
//import { useDialog } from 'components/v2/FormElements/Dialog';
// HOC
import{withFeatureState}from'./state';// FlexTable
import{Delete}from'components/v2/FlexTable/RowActionItem';// TODO: These are going to have to be differentiated somehow
export var ClientCredentialDelete=withFeatureState(Delete);export var SecretKeyDelete=withFeatureState(Delete);